import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNTreatmentKine } from 'src/app/models/cntreatmentkine';
import { ContactService } from 'src/app/services/contact.service';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-treatment-kine',
  templateUrl: './treatment-kine.component.html',
  styleUrls: ['./treatment-kine.component.scss']
})
export class TreatmentKineComponent implements OnInit {

  private theTreatment: CNTreatmentKine;

  public sessionCounter: string[] = [];
  @Input() contact: CNConsultation;
  @Output() applyGroup = new EventEmitter<string>();

  constructor(private services: ServicesService, private contactSrv: ContactService) { }

  ngOnInit(): void {
  }

  @Input() set treatment(treatment: CNTreatmentKine) {
    this.theTreatment = treatment;
    // tslint:disable-next-line:max-line-length
    this.sessionCounter = (this.treatment.sessionCount) ? Array.from({length: this.treatment.sessionCount}, (_, i) => (i + 1).toString()) : [];
  }

  get treatment(): CNTreatmentKine {
    return this.theTreatment;
  }

  setSessionCount(count: number): void {
    this.theTreatment.sessionCount = count;
    this.sessionCounter = Array.from({length: count}, (_, i) => (i + 1).toString());
  }

  setSessionCheck(index: string, event: MatCheckboxChange) {
    const sessions = this.theTreatment.sessions;
    sessions.set(index, event.checked);
    this.theTreatment.sessions = sessions;
    if (this.contact) {
      // get rules
      const rule = this.services.contactCodeRule(this.contact.type);
      const group = rule.groupCodeForCount(parseInt(index, 10));
      if (group) {
        this.applyGroup.emit(group);
        this.contactSrv.applyContactGroup(group);
      }
    }
  }

  sessionCheck(index: string): boolean {
    return this.theTreatment.sessions.get(index);
  }
}
